export enum CalculationContactStatusEnum {
  Planned = 'planned',
  Realized = 'realized',
}
